/** Created by azhou on 2019/2/15.*/
<template>
  <div class="d-center nrk-form-item">
    <span :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>：
    <el-select v-model="valueInside"
               class="w-100" size="small"
               :class="[Height?'text-center':'']"
               style="flex: 1;"
               @change="(v)=>{ this.$emit('input',v) }"
               :placeholder="placeholder">
      <el-option v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  export default {
    name: 'LeftTextSelect',
    props: {
      value: {},
      width: {
        type: Number,
        default:100
      },
      leftText: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      Height: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        valueInside: ''
      }
    },
    created() {
      //当prop传入的值没有发生变化时，组件被重新创建后需要再次赋值
      if (this.value) this.valueInside = this.value;
    },
    watch: {
      value() { this.valueInside = this.value; }
    }
  }
</script>

<style>
  .text-center .el-input--small .el-input__inner{
    height: 40px;
    line-height: 40px;
  }
</style>